import {Directive, Input, ElementRef, OnInit, OnChanges, SimpleChanges, inject, SecurityContext} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

enum RunTiming {
    Before = 'before',
    After = 'after'
}

@Directive({
    selector: '[runScripts]',
    standalone: false
})
export class RunScriptsDirective implements  OnInit, OnChanges {
    sanitizer: DomSanitizer;

    @Input('runScripts') timing;
    @Input('scriptsHtml') scriptsHtml;

    constructor(private eleRef: ElementRef) {
        this.sanitizer = inject(DomSanitizer);
    }
    scripts;
    newScript;

    reinsertScripts() {
        this.timing = this.timing ? this.timing : RunTiming.Before;
        // Get the scripts
        this.scripts = <HTMLScriptElement[]>this.eleRef.nativeElement.getElementsByTagName('script');

        // Run them in sequence (remember NodeLists are live)
        this.continueLoading();
    }


    continueLoading() {
        let script;
        // While we have a script to load...
        while (this.scripts.length) {
            // Get it and remove it from the DOM
            script = this.scripts[0];
            script.parentNode.removeChild(script);

            const timingVal = (script.attributes?.getNamedItem("run")?.value) ?? RunTiming.Before;

            if (this.timing === timingVal) {
                // Create a replacement for it
                this.newScript = document.createElement('script');

                // External?
                if (script.src) {
                    // Yes, we'll have to wait until it's loaded before continuing
                    this.newScript.onerror = this.continueLoadingOnError.bind(this.newScript, this);
                    this.newScript.onload = this.continueLoadingOnLoad.bind(this.newScript, this);
                    this.newScript.onreadystatechange = this.continueLoadingOnReady.bind(this.newScript, this);
                    this.newScript.src = script.src;
                }
                else {
                    // No, we can do it right away
                    this.newScript.text = script.text;
                }

                // Start the script
                this.eleRef.nativeElement.parentElement.appendChild(this.newScript);

                // If it's external, wait for callback
                if (script.src) {
                    return;
                }
            }

        }

        // All scripts loaded
        this.newScript = undefined;

    }

    // Callback on most browsers when a script is loaded
    continueLoadingOnLoad(self) {
        // Defend against duplicate calls
        if (this === self.newScript) {
            self.continueLoading();
        }
    }

    // Callback on most browsers when a script fails to load
    continueLoadingOnError(self) {
        // Defend against duplicate calls
        if (this === self.newScript) {
            self.continueLoading();
        }
    }

    // Callback on IE when a script's loading status changes
    continueLoadingOnReady(self) {
        // Defend against duplicate calls and check whether the
        // script is complete (complete = loaded or error)
        if (this === self.newScript && self.readyState === "complete") {
            self.continueLoading();
        }
    }

    ngOnInit() {
        this.reinsertScripts();
    }
    
    ngOnChanges(changes: SimpleChanges) {
        if(changes['scriptsHtml'] && !changes['scriptsHtml'].firstChange) {
            this.reinsertScripts();
        }
    }
}
